import Paper from "@mui/material/Paper";

export default function LoginCard({ children }) {
    return (
        <Paper
            elevation={6}
            sx={{
                padding: 4,
                width: 720,
                maxWidth: "100%",
                borderRadius: 2,
                minHeight: 500
            }}
        >
            {children}
        </Paper>
    );
}
